import request from '@/utils/request'
import URL from './urlTranslator'

// 获取Ocr全部数据
export function getOcrList(data) {
  return request({
    url: URL.sys.getOcrList,
    method: 'post',
    data
  })
}

// 获取文字映射列表
export function getOcrMapperList(data) {
  return request({
    url: URL.sys.getOcrMapperList,
    method: 'post',
    data
  })
}

// 新增编辑映射
export function saveOcrMapper(data) {
  return request({
    url: URL.sys.saveOcrMapper,
    method: 'post',
    data
  })
}

// 删除映射
export function deleteOcrMapper(data) {
  return request({
    url: URL.sys.deleteOcrMapper,
    method: 'post',
    data
  })
}

// 获取录单字段列表
export function getOcrFieldList(data) {
  return request({
    url: URL.sys.getOcrFieldList,
    method: 'post',
    data
  })
}

// 新增编辑录单字段
export function saveOcrField(data) {
  return request({
    url: URL.sys.saveOcrField,
    method: 'post',
    data
  })
}

// 新增编辑录单字段 校验信息
export function saveOcrFieldCheckConfig(data) {
  return request({
    url: URL.sys.saveOcrFieldCheckConfig,
    method: 'post',
    data
  })
}

// 新增编辑录单字段 校验信息
export function getIfAutoBookingEnable(params) {
  return request({
    url: URL.sys.getIfAutoBookingEnable,
    method: 'get',
    params
  })
}

// 映射，应用总部
export function saveMapperApplyHq(data) {
  return request({
    url: URL.sys.saveMapperApplyHq,
    method: 'post',
    data
  })
}
